import { Chip, InputLabel, List, ListItem } from '@mui/material';
import _ from 'lodash';

export default function ItemsField({ input: { onChange, value, ...input } }) {
  const handleDelete = (type, deletedEntry) => () => {
    onChange({
      ...value,
      [type]: value[type].filter((entry) => entry !== deletedEntry),
    });
  };

  return value ? (
    <List>
      {Object.entries(value)
        .filter(([key, items]) => items && items.length > 0)
        .map((entry) => (
          <ListItem key={entry[0]}>
            <div>
              <InputLabel shrink>{_.startCase(entry[0])}</InputLabel>
              {entry[1].map((item) => (
                <Chip
                  key={item}
                  label={item}
                  onDelete={handleDelete(entry[0], item)}
                  sx={{ m: 0.5 }}
                />
              ))}
            </div>
          </ListItem>
        ))}
    </List>
  ) : null;
}
